import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-adhoc-feedback.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-adhoc-feedback.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import * as ViewApplicationFeedbackConstants from "./view-application-adhoc-feedback.constants";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedConstants } from "../../../shared/constants/shared.constants";
import { AlertType } from "../../../shared/models/alert";
import { AppControllerService } from "../../../app-controller.service";
import { UserInformationService } from "../../../shared/services/user/user-information.service";
import { ApplicationService } from "../shared/application.service";
import * as FeedbackDetailsConstants from "../feedback-details/feedback-details.constants";
import { take, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { AppConfig } from "../../../app.config";
let ViewApplicationAdhocFeedbackComponent = class ViewApplicationAdhocFeedbackComponent {
    activeModal;
    appController;
    applicationService;
    userInformationService;
    _destroy$ = new Subject();
    dialogTitle;
    cancelBtnLabel = ViewApplicationFeedbackConstants.CANCEL_TEXT;
    errorObjectName = ViewApplicationFeedbackConstants.OBJECT_NAME;
    sendBtnLabel = ViewApplicationFeedbackConstants.SEND_TEXT;
    feedbackForm;
    formData;
    nameFormControl = FeedbackDetailsConstants.NAME_FORM_CONTROL;
    emailFormControl = FeedbackDetailsConstants.EMAIL_FORM_CONTROL;
    subjectFormControl = FeedbackDetailsConstants.SUBJECT_FORM_CONTROL;
    messageFormControl = FeedbackDetailsConstants.MESSAGE_FORM_CONTROL;
    screenshotFormControl = FeedbackDetailsConstants.SCREENSHOT_FORM_CONTROL;
    feedbackProperties = FeedbackDetailsConstants.FEEDBACK_PROPERTIES;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    constructor(activeModal, appController, applicationService, userInformationService) {
        this.activeModal = activeModal;
        this.appController = appController;
        this.applicationService = applicationService;
        this.userInformationService = userInformationService;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
        this.initializeForm();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    onBtnSendEmailClicked() {
        if (this.feedbackForm.valid) {
            const data = {};
            this.setFormDataValues();
            data.formData = this.formData;
            const sendScreenshot = this.feedbackForm.get(this.screenshotFormControl).value;
            if (sendScreenshot) {
                data.sendScreenshot = sendScreenshot;
            }
            this.activeModal.close(data);
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    onBtnCancelClicked() {
        this.activeModal.close();
    }
    setFormDataValues() {
        this.formData.append(this.feedbackProperties.name, this.feedbackForm.get(this.nameFormControl).value);
        this.formData.append(this.feedbackProperties.senderEmail, this.feedbackForm.get(this.emailFormControl).value);
        this.formData.append(this.feedbackProperties.subject, this.feedbackForm.get(this.subjectFormControl).value);
        this.formData.append(this.feedbackProperties.message, this.feedbackForm.get(this.messageFormControl).value);
    }
    initializeForm() {
        this.formData = new FormData();
        this.userInformationService.$authenticatedUser.pipe(takeUntil(this._destroy$), take(1)).subscribe(user => {
            this.feedbackForm = new FormGroup({
                name: new FormControl(`${user.firstName} ${user.lastName}`, Validators.required),
                email: new FormControl(`${user.email}`, [Validators.required, Validators.email]),
                subject: new FormControl(null, Validators.required),
                screenShot: new FormControl(null),
                message: new FormControl(null, Validators.required),
            });
        });
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: AppControllerService },
        { type: ApplicationService },
        { type: UserInformationService }
    ];
    static propDecorators = {
        dialogTitle: [{ type: Input }],
        formData: [{ type: Input }]
    };
};
ViewApplicationAdhocFeedbackComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-adhoc-feedback",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationAdhocFeedbackComponent);
export { ViewApplicationAdhocFeedbackComponent };
